export const APP_ID = 'e3d68caa-1d5b-4614-8740-105fddc9794e';
export const API = (process.env.REACT_APP_API_URL || 'https://api.digitalwerks.com').replace(/\/$/, '');
export const loginUrl = '/login';
export async function request(path, options = {}) {
  const response = await fetch(`${API}${path}`, { credentials: 'include', cache: 'no-store', ...options, headers: { 'Content-Type': 'application/json', ...options.headers } });
  if (options.csv && response.ok) return response.blob();
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw Object.assign(new Error(typeof data.error === 'string' ? data.error : data.error?.message || data.msg || 'Unable to load this information. Please retry.'), { status: response.status });
  return data;
}
export const post = (path, body, options) => request(path, { method: 'POST', body: JSON.stringify(body), ...options });
export const number = value => value == null ? 'Unavailable' : new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value);
export const percent = value => value == null ? 'Unavailable' : `${value.toFixed(2)}%`;
export function defaultRange(today = new Date()) {
  const end = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() - 1));
  const start = new Date(end); start.setUTCDate(start.getUTCDate() - 29);
  return { startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
}
